// extracted by mini-css-extract-plugin
export default {"wrapper":"info-message__wrapper___hO5EN","withFooter":"info-message__withFooter___POFMb","desc":"info-message__desc___goJkL"};